export default () => {
  // 種別が受講のときのみ、学科教習枠を無効にする
  const setLessonSlotStatus = (kind) => {
    const lessonSlot = document.getElementById('passcode_lesson_slot_id');
    if (kind.value === 'attendance') {
      lessonSlot.disabled = false;
    } else {
      lessonSlot.disabled = true;
      lessonSlot.value = '';
    }
  }

  const passcodeKind = document.getElementById('passcode_kind');
  if (passcodeKind && !passcodeKind.disabled) {
    passcodeKind.addEventListener('change', () => setLessonSlotStatus(passcodeKind), false);
    window.addEventListener('load', () => setLessonSlotStatus(passcodeKind));
  }
}
